module.exports = __webpack_public_path__ + "img/photo3_4.614a3eef.jpg";